import { isValidElement } from 'react';
import { MessageOptions } from 'tdesign-react';
import Message from 'common/components/Message';
import { ERROR_MSG, getUnknownMistake } from 'common/constants/Constants';

type TError = object | React.ReactNode;

export const handleError = (error: TError, messageOpts?: MessageOptions): any => {
  if (_.isString(error) || isValidElement(error)) {
    return Message.error({ content: error, ...messageOpts });
  }

  const errorCode = _.get(error, 'data.errCode') || _.get(error, 'errCode');
  const errorMsg = _.get(error, 'data.errMessage') || _.get(error, 'errMessage');
  const httpStatus = _.get(error, 'status');

  if ([401, 403, 499].includes(httpStatus)) return null;

  if (ERROR_MSG.has(errorCode)) {
    const msg = ERROR_MSG.get(errorCode);
    return msg ? Message.error({ content: msg, ...messageOpts }) : null;
  }

  if (ERROR_MSG.has(httpStatus)) {
    const msg = ERROR_MSG.get(httpStatus);
    return msg ? Message.error({ content: msg, ...messageOpts }) : null;
  }

  if (errorMsg) {
    return Message.error({ content: errorMsg, ...messageOpts });
  }

  return Message.error({ content: getUnknownMistake(), ...messageOpts });
};

export const handleSuccess = (data: React.ReactNode | MessageOptions) => {
  if (_.isString(data) || isValidElement(data)) {
    Message.success({ content: data });
  } else {
    Message.success(data as MessageOptions);
  }
};
